<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <div class="home-title mt-4 card-title">
            The Shipbuilders
            <v-btn text to="/">Go Back</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row wrap>
        <v-col lg="12" sm="12">
          <v-card>
            <v-card-text
              class="body-1"
            >Within a few years of the completion of the first canal, shipbuilding, ship carpentry, blacksmiths and machine shops became important components of the local marine industry. Schooners and other sailing ships were the earliest vessels to be built, while local craftsmen later applied their skills to building steam-powered vessels like tugboats and yachts, along with smaller dinghies and fishing boats. In the late 1800s, many large steamships were built in Great Britain, sailed across to Montreal, and the hulls cut in half to be towed in sections of through the canal. Local companies like Neff & Misener of Humberstone contributed to the final fitting out of these steamships for service, in addition to providing valuable repair and maintenance services for the marine industry</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Ad_1__Shipbuilding.jpg"></v-img>
  <image-viewer source="Ad_1__Shipbuilding.jpg"></image-viewer>
            <v-card-text class="body-1">Advertisement taken from the 1879 Lincoln-Welland Directory.</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_1__Ship_Building_976_280_5.jpg"></v-img>
 <image-viewer source="Photo_1__Ship_Building_976_280_5.jpg"></image-viewer>
            <v-card-text class="body-1">
              A partially finished tugboat hull on the east bank of the harbour near the mouth of the canal, c.1900. This was the location for most shipbuilding in Port Colborne.
              Port Colborne Historical & Marine Museum 976.280.5
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_2__Shipbuilding_976_280_3.jpg"></v-img>
 <image-viewer source="Photo_2__Shipbuilding_976_280_3.jpg"></image-viewer>
            <v-card-text class="body-1">
              Three men standing on the hull of a partially-built tug. The man on the right is George Christmas, c. 1900.
              Port Colborne Historical & Marine Museum 976.280.3
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Document_1__Shipbuilding_986_33_1.jpg"></v-img>
 <image-viewer source="Document_1__Shipbuilding_986_33_1.jpg"></image-viewer>
            <v-card-text class="body-1">
              Bill of Landing for the schooner, Lord Seaton, the first vessel confirmed to be built in Port Colborne about 1841. The ship was named after the port’s namesake, Sir John Colborne, Lord Seaton.
              Port Colborne Historical & Marine Museum 986.33.1
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
export default {
  name: "TheShipBuilders",
  components: {},
};
</script>

<style>
</style>